import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";

import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import {
  formatLength,
  images,
  showNotification,
  truncateString,
} from "../../../../constants";
import CancelIcon from '@mui/icons-material/Cancel';
import StatusDropdown from "../../../../common/StatusDropdown";
import { updateQuickTale } from "../../hooks/QuickTalesHooks";
import { Toast } from "../../../../common/alert";
import { useQuickTalesContext } from "../../../../providers/OrganizationAdmin/QuickTalesProvider";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";
import { useAuth } from "../../../../hooks";
import { getCreatedByDisplayFromQT } from "../../../../utils/createdByUtils";


const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  setSelectedAudioFile,
  setSelectedImage,
  handleNavigateToDetails,
  columnWidths,
}) => {
  const { currentUser } = useAuth();
  const { handleGetAllQuickTales, loading, setLoading } =
    useQuickTalesContext();
  const { currentOrganization } = useOrganizationContext();


  const handleUpdateQuickTaleStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        approvalStatus: {
          status: status,
          updatedAt: new Date(),
          updatedBy: currentUser?.userName,
        },
      };
      console.log(status, row.id);
      let responseTemp = await updateQuickTale(row.id, dataTemp);
      console.log("update quicktale response:", responseTemp);
      await handleGetAllQuickTales();
      showNotification("QuickTale updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const dropdownOptions = ["approved", "pending", "denied"];

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        align="left"
        scope="row"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.title || 300,
          minWidth: columnWidths?.title || 300,
          maxWidth: columnWidths?.title || 300,
        }}
        title={row?.title}
      >
        {row?.title && truncateString(row?.title, 40)}
      </TableCell>
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 90,
          minWidth: columnWidths?.photo || 90,
          maxWidth: columnWidths?.photo || 90,
        }}
        onClick={() => {
          setSelectedImage(
            row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        <img
          src={row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo}
          // src={images.tableDummyImage}
          // alt="table image"
          style={{ minWidth: 45, height: 40 }}
        />
      </TableCell>
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.audio || 90,
          minWidth: columnWidths?.audio || 90,
          maxWidth: columnWidths?.audio || 90,
        }}
        onClick={() => {
          if (row?.processedAudioUrl || row?.audioUrl) {
            setSelectedAudioFile(row?.processedAudioUrl || row?.audioUrl);
            handleAudioModalOpen();
          }
        }}
      >
        {(row?.processedAudioUrl || row?.audioUrl) ? (
          <PlayCircleFilledWhiteOutlinedIcon
            fontSize="large"
            style={{ color: "#00A7CD" }}
          />
        ) : (
          <CancelIcon
            fontSize="large"
            style={{ color: "#D32F2F" }}
          />
        )}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.areaNameResolved || 170,
          minWidth: columnWidths?.areaNameResolved || 170,
          maxWidth: columnWidths?.areaNameResolved || 170,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={row?.areaNameResolved || ""}
      >
        {row?.areaNameResolved || ""}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 100,

          minWidth: columnWidths?.id || 100,
          maxWidth: columnWidths?.id || 100,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',

        }}
        title={row?.id}
      >
        {row.id}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdBy || 130,
          minWidth: columnWidths?.createdBy || 100,
          maxWidth: columnWidths?.createdBy || 180,
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }}
      >
        {(() => {
          // When createdByData is missing (org creators aren't fetched in the
          // list) but the raw id matches the admin's org, show the org name.
          if (
            !row?.createdByData &&
            currentOrganization?.id &&
            row?.createdBy === currentOrganization.id
          ) {
            return currentOrganization.name || row?.createdBy || "";
          }
          return getCreatedByDisplayFromQT(row);
        })()}
      </TableCell>

      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["narratorData.userName"] || 120,
          minWidth: columnWidths?.["narratorData.userName"] || 120,
          maxWidth: columnWidths?.["narratorData.userName"] || 120,
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }}
      >
        {row.narratorData ? row.narratorData?.userName : row.narrator}
      </TableCell>
      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.status || 150,
          minWidth: columnWidths?.status || 150,
          maxWidth: columnWidths?.status || 150,
        }}
      >
        {row.status}
        {/*
      {row.whoCanListen}
      */}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.isDraft || 110,
          minWidth: columnWidths?.isDraft || 110,
          maxWidth: columnWidths?.isDraft || 110,
        }}
      >
        {row.isDraft === true ? "Draft" : "Finished"}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.audioLength || 100,
          minWidth: columnWidths?.audioLength || 100,
          maxWidth: columnWidths?.audioLength || 100,
        }}
      >
        {row.audioLength && formatLength(row.audioLength)}
      </TableCell>

      <TableCell
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.["approvalStatus.status"] || 170,
          minWidth: columnWidths?.["approvalStatus.status"] || 170,
          maxWidth: columnWidths?.["approvalStatus.status"] || 170,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.approvalStatus?.status}
          onChange={handleUpdateQuickTaleStatus}
        />
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["approvalStatus.updatedAt"] || 180,
          minWidth: columnWidths?.["approvalStatus.updatedAt"] || 180,
          maxWidth: columnWidths?.["approvalStatus.updatedAt"] || 180,
        }}
      >
        {/*date modified*/}
        {/* {row?.approvalStatus?.updatedAt && */}
        {row?.approvalStatus?.updatedAt &&
          moment
            .unix(row?.approvalStatus?.updatedAt.seconds)
            .format("MM/DD/YYYY HH:mm:ss")}
      </TableCell>
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  // paddingLeft: 5,
  // fontWeight: 600,
  color: "#00A7CD",
  border: "1px solid #BABABA",
  fontFamily: "Avenir Book, sans-serif",
  overFlow: "hidden",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  overFlow: "hidden",
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};
